var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNewRecordBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98072 7.79218C8.98072 7.79218 10.5847 6.16841 10.5847 4.18822C10.5847 2.20802 8.98072 0.564453 6.98072 0.564453C4.98072 0.564453 3.37676 2.18822 3.37676 4.16841C3.37676 6.14861 4.98072 7.79218 6.98072 7.79218ZM6.98072 1.51495C8.44607 1.51495 9.63419 2.70307 9.63419 4.16841C9.63419 5.63376 8.44607 6.82188 6.98072 6.82188C5.51537 6.82188 4.32725 5.65356 4.32725 4.18822C4.32725 2.72287 5.51537 1.51495 6.98072 1.51495ZM0.723294 13.4357H13.2777C13.5352 13.4357 13.753 13.2179 13.753 12.9605C13.753 10.4654 11.7134 8.42584 9.21834 8.42584H4.7827C2.28765 8.42584 0.248047 10.4654 0.248047 12.9605C0.248047 13.2179 0.465869 13.4357 0.723294 13.4357ZM4.7827 9.37633H9.21834C11.0401 9.37633 12.5253 10.7229 12.7629 12.4852H1.23815C1.47577 10.7229 2.96092 9.37633 4.7827 9.37633Z",
    fill: "#387ED1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewRecordBlue);
export default __webpack_public_path__ + "static/media/AddNewRecordBlue.3b90bbfe.svg";
export { ForwardRef as ReactComponent };